var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.877 6.5C9.978 6.5 10.055 6.53 10.133 6.608L15.077 11.553C15.131 11.607 15.156 11.649 15.168 11.677V11.678C15.183 11.713 15.191 11.753 15.191 11.802C15.191 11.85 15.183 11.89 15.168 11.926V11.927C15.156 11.955 15.131 11.997 15.077 12.051L10.108 17.02C10.031 17.097 9.963 17.119 9.883 17.116C9.789 17.113 9.708 17.081 9.622 16.995C9.544 16.917 9.513 16.84 9.513 16.739C9.513 16.638 9.544 16.562 9.622 16.483L14.304 11.802L9.597 7.095C9.519 7.017 9.497 6.951 9.5 6.87C9.503 6.776 9.536 6.694 9.622 6.608C9.7 6.531 9.776 6.5 9.877 6.5Z",
    fill: "#F3EFEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.636e5b94aa6adfd47c9301d22d68ee59.svg";
export { ForwardRef as ReactComponent };